import { BorderColor, Delete, MoreVert } from '@mui/icons-material'
import { DialogContentText, IconButton, ListItemIcon, ListItemText } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import { t } from 'i18next'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import React, { useState } from 'react'
import { Trans } from 'react-i18next'
import { useNotification } from '../../store/redux/hooks'
import { useDeleteCostMutation } from '../../store/redux/reducers/costSlice'
import { StyledMenu } from '../../styles/PopupStyles'
import ConfirmationDialog from '../Dialog/ConfirmationDialog'

type CostActionMenuProps = {
  costId: string
  setEditCost: () => void
  isLeader: boolean
  isMyCosts: boolean
}

const CostActionMenu = ({ costId, setEditCost, isLeader, isMyCosts }: CostActionMenuProps) => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false)
  const [deleteCost] = useDeleteCostMutation()
  const { displayNotification } = useNotification()

  const handleDeleteCost = async (popupState: any) => {
    if (costId === null) {
      return
    }
    try {
      await deleteCost(costId).unwrap()
      displayNotification({ message: t('components.costSidebar.alert.costDeleted'), type: 'success' })
    } catch (_) {
      displayNotification({ message: t('components.costSidebar.alert.costDeleteError'), type: 'error' })
    }
    setOpenDeleteDialog(false)
    popupState.close()
  }

  return (
    <PopupState
      popupId={`cost-action-menu-${costId}`}
      variant={'popover'}
      parentPopupState={null}
      disableAutoFocus={null}
    >
      {popupState => (
        <React.Fragment>
          <IconButton
            aria-label={t('components.popover.moreOptions')}
            disabled={isLeader && !isMyCosts}
            {...bindTrigger(popupState)}
            sx={{ color: 'inherit' }}
          >
            <MoreVert />
          </IconButton>
          <StyledMenu sx={{ '& .MuiPaper-root': { minWidth: '50px' } }} {...bindMenu(popupState)}>
            <MenuItem onClick={setEditCost}>
              <ListItemIcon>
                <BorderColor />
              </ListItemIcon>
              <ListItemText>{t('components.popover.edit')}</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => setOpenDeleteDialog(true)}>
              <ListItemIcon>
                <Delete />
              </ListItemIcon>
              <ListItemText>{t('components.popover.delete')}</ListItemText>
            </MenuItem>
          </StyledMenu>

          <ConfirmationDialog
            open={openDeleteDialog}
            setOpen={setOpenDeleteDialog}
            handleConfirm={() => handleDeleteCost(popupState)}
            title={t('components.costSidebar.dialog.delete.title')}
            content={
              <DialogContentText>
                <Trans i18nKey="components.costSidebar.dialog.delete.content" values={{ name: costId }} />
              </DialogContentText>
            }
            confirmationButtonText={t('page.projects.dialog.delete.confirm')}
          />
        </React.Fragment>
      )}
    </PopupState>
  )
}

export default CostActionMenu
